import {TokenCache, TokenCacheInitOptions} from "../cache/tokencache";
import {ReadStream} from "fs";

export type ApiUrl = "https://qyapi.weixin.qq.com/cgi-bin/";

/**
 * UNIX 时间戳
 */
export type timestamp = number;

/*
* 企业微信参数
* */
export interface Corp {
  corpId: string;  // 企业ID
  corpSecret: string; // 应用的凭证密钥
  mailSecret: string; // 企业的通讯录密钥
  checkInSecret: string; // 企业的打卡密钥
  approvalSecret: string; // 企业的审批密钥
  apiUrl?: string; // 企业微信api base url
}

/*
* token 类型
* */
export enum TokenType {
  corpSecret = 0,
  mailSecret = 1,
  checkInSecret = 2,
  approvalSecret = 3
}

/**
 * 初始化参数
 */
export interface WechatInitOptions {
  corp: Corp; // 企业微信参数
  tokenCache: TokenCache;    // token 缓存设置参数
}


/*
* 应用文本消息或markdown消息
* */
export interface WechatTextMsg {
  toUser?: string;
  toParty?: string;
  toTag?: string;
  agentId: number;
  content: string;
  safe?: number;
}

/*
* 应用文件消息
* */
export interface WechatFileMsg {
  toUser?: string;
  toParty?: string;
  toTag?: string;
  agentId: number;
  mediaId: number;
  safe?: number;
}




/*
* 素材文件类型
* */
export enum MediaType {
  IMAGE = "image",
  VOICE = "voice",
  VIDEO = "video",
  FILE = "file"
}

/*
* 素材文件
* */
export interface MediaFile {
  toUser?: string;
  toParty?: string;
  toTag?: string;
  agentId: number;
  mediaId: number;
  safe?: number;
}

/*
* 上传文件选项
* */
export interface FileOptions {
  filename: string;
  contentType: string;
}

/*
* 上传文件
* */
export interface File {
  value: ReadStream;
  options: FileOptions;
}

/*
* 打卡类型
* */
export enum OpenCheckInDataType {
  GoToWork = 1,
  GoOut = 2,
  All = 3
}

/**
 * 群聊
 */
export interface AppChat {
  name?: string; // 群聊名称
  owner?: string;  // 群主
  userlist: string[]; // 用户列表
  chatid?: string;  // 群聊标识
}

/**
 * 修改时的群聊信息
 */
export interface AppChatInfo {
  chatid: string;  // 群聊标识
  name?: string; // 群聊名称
  owner?: string;  // 群主
  add_user_list?: string[]; // 添加成员的id列表
  del_user_list?: string[]; // 踢出成员的id列表
}



/*
* 群聊文本或markdown消息
* */
export interface AppChatMsg {
  chatid: string;
  msgtype: "text" | "markdown";
  content: string;
  safe?: number;
}


